<!-- <div class="form-group radio-button-group">
<button type="button" [id]="config['name']+'_'+camelCase(item.label)" [name]="config['name']+'_'+item.label" class="btn rad-btn btn-pad btn-sm"
    [ngClass]="{'btn-primary':(config.value  === item.code),'btn-secondary':(config.value  !== item.code),'font-16':defaultStyle,
    'health-button': getLabel(item.label), 'currentDate-btn': (config['name'] === 'currentDate')}"
  [disabled]="config['readonly'] || item.disable" *ngFor="let item of config['radioButtonOptions'];let i=index; let c = count;"
[value]="item.code" (click)="radioBtnChangeHandler($event.target.value)">{{item.label}}</button>
</div> -->
<div class="form-group radio-button-group">
  <span class="visually-hidden" id="alertMessage" aria-live="polite">Alert Message</span>
  @for (item of config['radioButtonOptions']; track item; let i = $index; let c = $count) {
    <button type="button" [id]="config['name']+'_'+camelCase(item.label)" [name]="config['name']+'_'+item.label"
        class="btn rad-btn btn-pad btn-sm questionGaps" [ngClass]="{
            'btn-primary':(config.value  === item.code),
            'btn-secondary':(config.value  !== item.code),'font-16':defaultStyle,
            'health-button': getLabel(item.label),
            'currentDate-btn': (config['name'] === 'currentDate'),
            'width-res': isbuttonViewChanged }" [disabled]="config['readonly'] || item.disable"
      [value]="item.code"
      (click)="radioBtnChangeHandler($event.target.value)" (blur)="onBlurRadioButton(i,c)"
    aria-controls="alertMessage">{{item.label}}</button>
  }
</div>